export var DeliveryZoneCountryZipCodeRule;
(function (DeliveryZoneCountryZipCodeRule) {
    DeliveryZoneCountryZipCodeRule["all"] = "all";
    DeliveryZoneCountryZipCodeRule["only"] = "only";
    DeliveryZoneCountryZipCodeRule["except"] = "except";
})(DeliveryZoneCountryZipCodeRule || (DeliveryZoneCountryZipCodeRule = {}));
export class DeliveryZonePriceConfig {
    price = null;
    maxWeight = null;
    constructor(price, maxWeight) {
        this.price = price;
        this.maxWeight = maxWeight;
    }
}
export var DurationUnit;
(function (DurationUnit) {
    DurationUnit["minutes"] = "minutes";
    DurationUnit["days"] = "days";
    DurationUnit["hours"] = "hours";
})(DurationUnit || (DurationUnit = {}));
export class Duration {
    value = null;
    unit = null;
    constructor(value, unit) {
        this.value = value;
        this.unit = unit;
    }
}
export class DeliveryZoneCountryConfig {
    code = null;
    validInZipCodesRule = null;
    validInZipCodesConfig = null;
    constructor(code, validInZipCodesRule, validInZipCodesConfig) {
        this.code = code;
        this.validInZipCodesConfig = validInZipCodesConfig;
        this.validInZipCodesRule = validInZipCodesRule;
    }
}
export class DeliveryZone {
    id = null;
    companyId = null;
    name = null;
    description = null;
    averageDeliveryTime = null;
    allowCustomDeliveryTime = false;
    countries = null;
    prices = null;
    constructor(id, data) {
        this.id = id || null;
        let definedKeys = Object.keys(this).filter((key) => key != "id");
        for (let key in data) {
            let value = data[key];
            let keyIsDefinedOnInstance = definedKeys.includes(key);
            if (value) {
                //replace all firebase dates with real dates
                if (value.seconds && value.toDate) {
                    value = value.toDate();
                }
            }
            if (keyIsDefinedOnInstance) {
                Object.assign(this, { [key]: value });
            }
        }
    }
}
